import { trackGkAirClick } from '~/features/catalog/article.server';
import { optionalProtectedAction } from '~/shell/utils/authUtil.server';
import { useBasePath } from '~/common/hooks/useBasePath.ts';
import { useCallback } from 'react';

export const action = optionalProtectedAction(async ({ request, api }) => {
  const formData = await request.formData();
  const trackingToken = formData.get('trackingToken') as string | null;
  const articleNumber = formData.get('articleNumber') as string | null;

  if (!trackingToken || !articleNumber) {
    return Response.json({ ok: false }, { status: 400 });
  }

  await trackGkAirClick(api, request.signal, articleNumber, trackingToken);

  return Response.json({ ok: true });
});

export function useGkAirTracking(articleNumber: string, trackingToken?: string) {
  const { path } = useBasePath();

  return useCallback(() => {
    if (!trackingToken) return;

    const formData = new FormData();
    formData.set('trackingToken', trackingToken);
    formData.set('articleNumber', articleNumber);

    fetch(`${path}/resources/catalog/gk-air-tracking`, {
      method: 'POST',
      body: formData
    }).catch(() => {
      // fire and forget - ignore errors
    });
  }, [path, articleNumber, trackingToken]);
}
